module.exports = "/packs/media/images/family_5-e2468c6c235f7d867b67f33313f420ef.jpg";